<div class="fill" [@phase]="phase"></div>
